import { format as formatDate } from 'date-fns';

export const skipReasons = {
  emptyBody: '問合せ本文が空のため、AIの下書きはありません。',
  noReferences: '参考にできる過去の類似問合せが少ないため、AIの下書きはありません。',
  needsJudgement: '過去の対応から返信を判断できなかったため、AIの下書きはありません。個別の判断が必要な内容の可能性があります。',
};

export default function AiDraftReplyNote({ aiDraftReply }) {
  if (!aiDraftReply) return null;

  const { body, skipReason, generatedAt } = aiDraftReply;
  const generatedAtText = generatedAt && formatDate(generatedAt.toDate ? generatedAt.toDate() : generatedAt, 'yyyy/MM/dd HH:mm');

  return (
    <div className={`alert ${body ? 'alert-info' : 'alert-secondary'} d-flex align-items-center small mb-3`}>
      <span className={`fas ${body ? 'fa-robot' : 'fa-info-circle'} mr-2`} />
      <div>
        {
          body
            ? '過去の類似した問合せへの返信をもとにAIが作成した下書きです。内容を確認・修正してから送信してください。'
            : (skipReasons[skipReason] || 'AIの下書きはありません。')
        }
        {generatedAtText && <span className="text-muted ml-1">({generatedAtText} 判定)</span>}
      </div>
    </div>
  );
}
